import Tooltip from "@root/components/tooltip";
import React from "react";

const BaseInput = ({ label, required, name, marker, error, children }) => (
    <div className="base-input">
        {label ? (
            <label htmlFor={name} className="base-input__label">
                {marker ? (
                    <span className="base-input__label-marker">{marker}</span>
                ) : null}
                {label}
                {required ? (
                    <span className="base-input__label-asterisk"> *</span>
                ) : null}
            </label>
        ) : null}
        <div className="base-input__input">
            {children}
        </div>
        {error 
            ? (
                <div className="base-input__error">
                    <Tooltip error={error} />
                </div>
            ) : null}
    </div>
);

BaseInput.defaultProps = {
    label: "",
    required: false,
    type: "text",
};

export default BaseInput;
